import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { UserContactUs, CustomResponse } from '../models/Auth';
import { BidData } from '../models/BidData';
import { BidDataRequest } from '../models/BidDataRequest';
import { BidDataRequestDTO } from '../models/BidDataRequestDTO';
import { BidSubmittedData } from '../models/BidSubmittedData';
import { BidSubmissionResult } from '../models/BidSubmissionResult';
import { CrashMailInputParameters } from '../models/CrashMailInputParameters';
import { IBidDataFile } from '../models/IBidDataFile';
import { MonthlyAwardDetails } from '../models/MonthlyAwardDetails';
import { SubmitResult } from '../models/SubmitBidResponseModel';
import { SubscriptionRequestModel } from '../models/SubscriptionRequestModel';
import { EmployeeVersionDetails } from '../models/EmployeeVersionDetails';
import { VersionModel } from '../models/VersionModel';
import { WbidApiService } from './wbid-api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OffLineEvents } from 'src/app/shared/models/LogDetails';
import { CrashMailService } from 'src/app/shared/services/crash-mail.service';

@Injectable({
  providedIn: 'root',
})
export class WbidCoreService {
  constructor(public ApiService: WbidApiService, private http: HttpClient ) {}

  public GetUserById(userId: string): Observable<any> {
    try {
      return this.ApiService.GetRestDataForGet(
        'user/GetUsersById?id=' + userId
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: GetUserById, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public GetLatestNewsFile(): Observable<SubmitResult> {
    try {
      return this.ApiService.GetRestDataForGet('BidData/GetLatestNewsPdfFile');
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: GetLatestNewsFile, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public SendMailToAdmin(user: UserContactUs): Observable<CustomResponse> {
    try {
      return this.ApiService.GetRestDataForPost(
        'user/SendContactUsMail/',
        user
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: SendMailToAdmin, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public SendErrorBidMailToAdmin(
    user: UserContactUs
  ): Observable<CustomResponse> {
    try {
      return this.ApiService.GetRestDataForPost('user/SendMailToAdmin/', user);
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: SendMailToAdmin, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public GetUserSubscriptionDetails(
    authRequest: SubscriptionRequestModel
  ): Observable<any> {
    try {
      return this.ApiService.GetRestDataForPost(
        'user/GetUserSubscriptionDetails',
        authRequest
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: GetUserSubscriptionDetails, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public getWbidEomVacationFiles(
    bidRequest: BidDataRequest
  ): Observable<IBidDataFile[]> {
    try {
      return this.ApiService.GetRestDataForPost(
        'BidData/GetWBidEOMVacationFile/',
        bidRequest,
        'json'
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: getWbidEomVacationFiles, ErrorMessage: ${error.stack.toString()}`;
    }
  }
  public SendCrashMail(
    crashMailInputParameters: CrashMailInputParameters
  ): Observable<any> {
    try {
      return this.ApiService.GetRestDataForPost(
        'user/SendCrashErrorMail/',
        crashMailInputParameters
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: SendCrashMail, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public async AsyncGetMonthlyBidFile(bidDataRequestDTO: BidDataRequestDTO) {
    try {
      const response = await this.ApiService.AsyncGetRestDataForPost(
        'BidData/GetMonthlyBidFiles/',
        bidDataRequestDTO
      );
      return response;
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: SendCrashMail, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public GetWBidBidDataFiles() {
    try {
      return this.ApiService.GetRestDataForGet('BidData/GetWbidBidDataFiles/');
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: GetWBidBidDataFiles, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public GetMonthlyAwardData(
    bidDetails: BidData
  ): Observable<MonthlyAwardDetails> {
    try {
      return this.ApiService.GetRestDataForPost(
        'BidData/GetMonthlyAwardData',
        bidDetails
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: GetMonthlyAwardData, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public GetBidSubmittedData(
    bidDetails: BidData
  ): Observable<BidSubmittedData> {
    try {
      return this.ApiService.GetRestDataForPost(
        'BidData/GetBidSubmittedData',
        bidDetails
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: GetMonthlyAwardData, ErrorMessage: ${error.stack.toString()}`;
    }
  }
  // for new API changes
  public saveBidSubmittedData(
    bidDetails: BidSubmissionResult
  ) {
    try {
      return this.ApiService.GetRestDataForPost(
        'BidData/SaveBidSubmittedData',
        bidDetails
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: saveBidSubmittedData, ErrorMessage: ${error.stack.toString()}`;
    }
  }

public GetAppVersion(
    versionDetails: EmployeeVersionDetails
  ): Observable<VersionModel> {
    try {
      return this.ApiService.GetRestDataForPost(
        'User/GetAppVersion/',
        versionDetails,
        'json'
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: GetAppVersion, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public getVacationFileForUser(
    BidDataRequest: BidDataRequestDTO
  ): Observable<IBidDataFile[]> {
    try {
      return this.ApiService.GetRestDataForPost(
        'BidData/getVacationFileForUser/',
        BidDataRequest
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: getVacationFileForUser, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  // stripe subscription
  checkout(data: any, response?: any): Observable<any> {
    const url =
      'https://www.crewbid-wbidmax.com/StripeHandler/CheckoutApi/CreateSubscription';
    return this.http.post<any>(url, data, {
      responseType: 'json',
    });
  }
  // paypal onetime subscription
  public paypalOnetime(data: any, response?: any): Observable<any> {
    const url =
      'https://www.crewbid-wbidmax.com/PayPalWebHook/CheckoutApi/CreateOneTime';
    return this.http.post<any>(url, data, {
      responseType: 'json',
    });
  }
  public paypalSubscribe(data: any, response?: any): Observable<any> {
    const url =
      'https://www.crewbid-wbidmax.com/PayPalWebHook/CheckoutApi/SubscriptionCreate';
    return this.http.post<any>(url, data, {
      responseType: 'json',
    });
  }
 
  // getting paypal customer address
  public getCustomerAddress(empNum: any) {
    try {
      return this.ApiService.GetRestDataForGet(
        'user/GetLatestPayPalCustomerAddress/?empNum=' + empNum,
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: getLatestPayPalCustomerAddress, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  // getting stripe customer address
  public getStripeCustomerAddress(empNum: any): Observable<any> {
    try {
      return this.ApiService.GetRestDataForGet(
        'user/GetLatestStripeCustomerAddress/?empNum=' + empNum,
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: getStripeCustomerAddress, ErrorMessage: ${error.stack.toString()}`;
    }
  }
  // stripe onetime subscription
  // public stripeOnetime(data: any, response?: any): Observable<any> {
  //   const url =
  //     'https://www.crewbid-wbidmax.com/StripeHandlerTest/CheckoutApi/CreatePaymentLink';
  //   return this.http.post<any>(url, data);
  // }
  public stripeSubscribe(data: any, response?: any): Observable<any> {
    const url =
      'https://www.crewbid-wbidmax.com/StripeWebHook/CheckoutApi/CreatePaymentLink';
    return this.http.post<any>(url, data, {
      responseType: 'json',
    });
  }
  // getting stripe payment status
  public GetStripePaymentStatus(invoiceId: string): Observable<any> {
    try {
      const url =
        'https://www.crewbid-wbidmax.com/StripeWebHook/api/StripePayWebHook/GetStripePaymentStatus?invoiceId=' +
        invoiceId;
      return this.http.get<any>(url, {
        responseType: 'text' as 'json',
      });
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: GetStripePaymentStatus, ErrorMessage: ${error.stack.toString()}`;
    }
  }
// checking buddy bid subscription
  public CheckValidSubscription(employeeDetails: any): Observable<any> {
    try {
      return this.ApiService.GetRestDataForPost(
        'user/CheckValidSubscriptionForEmployees/',
        employeeDetails
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: CheckValidSubscription, ErrorMessage: ${error.stack.toString()}`;
    }
  }
   // to add logdetails for bid timeout  and 
   public LogOffLineEvents(offLineEvents:OffLineEvents) {
    try {
      return this.ApiService.GetRestDataForPost(
        "User/LogOffLineEvents",
        offLineEvents
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: LogOffLineEvents, ErrorMessage: ${error.stack.toString()}`;
     
    }
  }
  public SendBidReceiptsToUsersEmail(bidReceiptData:any) {
    try {
      return this.ApiService.GetRestDataForPost(
        "BidData/SaveFormattedBidReceiptAndEmail",
        bidReceiptData
      );
    } catch (error) {
      // this.crashMail.sendCrashMail(
      //   `Function Name: LogOffLineEvents  ${error.stack.toString()}`
      // );
    }
  }
     public GetApplicationLoadDatas(FromApp:any) {
    try {
      return this.ApiService.GetRestDataForPost(
        "User/GetApplicationLoadDatas",
        FromApp
      );
    } catch (error) {
      throw `ClassName:WbidCoreService, FunctionName: GetApplicationLoadDatas, ErrorMessage: ${error.stack.toString()}`;
     
    }
  }


}
